import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';

@Pipe({
  name: 'locationDataParcels2SectionTitle',
  standalone: true
})
export class LocationDataParcels2SectionTitlePipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    if (application?.service?.url === '/opinia-w-sprawie-wydania-decyzji') {
      return 'Działki przylegające do działek drogowych';
    }
    switch (true) {
      case application?.applicationSubject === 'Przebudowy zjazdu': {
        return 'Działki do których prowadzi zjazd';
      }
      default: {
        return 'Działki do których będzie prowadził projektowany zjazd';
      }
    }
  }
}
